import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Calendar } from 'lucide-react';

const FloatingAppointmentButton = ({ onClick }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { pathname } = useLocation();
  const isEs = pathname === '/es' || pathname.startsWith('/es/');

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  if (!isVisible) return null;

  const label    = isEs ? 'Reservar Cita' : 'Book Appointment';
  const ariaText = isEs ? 'Reservar una cita' : 'Book an Appointment';

  return (
    <button
      onClick={onClick}
      className="fixed left-0 top-1/3 z-[90] bg-teal-600 hover:bg-teal-700 text-white shadow-lg hover:shadow-xl transition-all duration-300 rounded-r-lg overflow-hidden group"
      aria-label={ariaText}
      style={{ writingMode: 'vertical-rl', textOrientation: 'mixed' }}
    >
      <div className="flex items-center gap-2 px-2 py-4">
        <Calendar className="w-4 h-4 rotate-90" />
        <span className="text-xs font-bold tracking-wider uppercase">
          {label}
        </span>
      </div>
    </button>
  );
};

export default FloatingAppointmentButton;
